import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Spinner } from '@shopify/polaris'
import SubscriptionHeader from './components/SubscriptionHeader'
import SubscriptionTrialMessage from './components/SubscriptionTrialMessage'
import SubscriptionContent from './components/SubscriptionContent'
import { shouldShowSubscription } from './utils/subscriptionUtils'

const SubscriptionComponent = () => {
	const { t } = useTranslation()
	const user = useSelector((state) => state.user.user)
	const currentPlan = useSelector((state) => state.subscription.currentPlan)
	const fetchingPaymentInfo = useSelector((state) => state.profile.fetchingPaymentInfo)
	const openProjectName = useSelector((state) => state.user.openProjectName)

	if (!user) {
		return null
	}

	const IS_TAX_AGENT = user.is_tax_agent || (user.is_manager && user.company.is_tax_agent)

	if (IS_TAX_AGENT) {
		return null
	}

	if (!shouldShowSubscription({ fetchingPaymentInfo, currentPlan, openProjectName })) {
		return null
	}

	const isTrial = currentPlan?.subscriptions?.status === 'trial'

	return (
		<div style={{ marginTop: 20 }}>
			<div className={'block-white'}>
				<SubscriptionHeader currentPlan={currentPlan} />
				{fetchingPaymentInfo ? (
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Spinner />
					</div>
				) : (
					<>
						{isTrial && <SubscriptionTrialMessage t={t} />}
						<SubscriptionContent
							currentPlan={currentPlan}
							openProjectName={openProjectName}
							t={t}
						/>
					</>
				)}
			</div>
		</div>
	)
}

export default SubscriptionComponent

